module.exports = __webpack_public_path__ + "static/media/logo.5ee046be.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 464
// module chunks = 1